export default __webpack_public_path__ + "static/curtain-0cb8bc8a1e2f3e988fb5217458de8254.png";